"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.walletsPath = exports.walletDetailPath = exports.subNavOptions = exports.settingsNav = exports.routeTemplate = exports.mainNavOptions = exports.AssignRoutes = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _config = _interopRequireDefault(require("../config"));
var _path = _interopRequireDefault(require("../helpers/path"));
var AdvancedTemplate = _interopRequireWildcard(require("./advancedTemplate"));
var RetailTemplate = _interopRequireWildcard(require("./retailTemplate"));
var LondonTemplate = _interopRequireWildcard(require("./londonTemplate"));
var MilanAltTemplate = _interopRequireWildcard(require("./milanAltTemplate"));
var EotcTemplate = _interopRequireWildcard(require("./EotcTemplate"));
var basicTradingTemplate = _interopRequireWildcard(require("./basicTradingTemplate"));
var v3standardTemplate = _interopRequireWildcard(require("./v3standardTemplate"));
var _settingsRoutes = require("./settingsRoutes");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mainNavOptions = exports.mainNavOptions = {
  mainNavItems: [],
  settingsPath: ''
};
var subNavOptions = exports.subNavOptions = {
  subNavItems: []
};
var settingsNav = exports.settingsNav = {
  items: []
};
var walletsPath = exports.walletsPath = {
  path: ''
};
var walletDetailPath = exports.walletDetailPath = {
  path: ''
};
var routeTemplate = exports.routeTemplate = {
  routes: function routes() {
    return /*#__PURE__*/_react["default"].createElement("div", null, " Loading ");
  }
};
var AssignRoutes = exports.AssignRoutes = function AssignRoutes() {
  switch (_config["default"].global.template) {
    case 'MILAN':
    case 'RETAIL':
      AssignRouteValues(RetailTemplate);
      break;
    case 'MILAN-ALT':
      AssignRouteValues(MilanAltTemplate);
      break;
    case 'NEWYORK':
    case 'ADVANCED':
      AssignRouteValues(AdvancedTemplate);
      break;
    case 'CAPETOWN':
    case 'BASICTRADING':
      AssignRouteValues(basicTradingTemplate);
      break;
    case 'LONDON':
      AssignRouteValues(LondonTemplate);
      break;
    case 'GALAXY':
    case 'EOTC':
      AssignRouteValues(EotcTemplate);
      break;
    case 'STANDARD':
      AssignRouteValues(v3standardTemplate);
      break;
    default:
      AssignRouteValues(RetailTemplate);
      break;
  }
};
var AssignRouteValues = function AssignRouteValues(source) {
  mainNavOptions.mainNavItems = source.mainNavOptions.mainNavItems;
  mainNavOptions.settingsPath = source.mainNavOptions.settingsPath;
  subNavOptions.subNavItems = source.subNavItems;
  settingsNav.items = _settingsRoutes.settingsNavItems;
  walletsPath.path = source.walletsPath;
  walletDetailPath.path = source.walletDetailPath;
  routeTemplate.routes = SetupRoutes(source.routesArray);
};
var SetupRoutes = function SetupRoutes(routesArray) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, routesArray.concat(_settingsRoutes.settingsRoutesArray).filter(function (i) {
    return i.show === undefined || i.show;
  }).map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      exact: item.exact,
      path: (0, _path["default"])(item.path),
      key: item.path,
      render: item.render
    });
  }));
};